import { render } from "./FolderDetails.vue?vue&type=template&id=687dfb8c&scoped=true"
const script = {}

import "./FolderDetails.vue?vue&type=style&index=0&id=687dfb8c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687dfb8c"]])

export default __exports__